export function getFullCategoryName(cat: string) : string {
    if(cat === "IF")
        return "INVESTMENT FUNDS"
    return cat
}